import store from "@/store";
import router from "@/router";
import { errorMessage } from "@/helper";

function requestErrorHandling({ response }) {
	const { status, data: { error } } = response;
	const { commit, dispatch } = store;

	if (status === 401) {
		commit('IS_LOGIN_USER', false);
		localStorage.clear();
		router?.push('/auth').then(() => {
		});
		dispatch("setAlert", { type: "error", message: "You are not authorized" });
	}

	if (status === 412 || status === 404) {
		errorMessage(error);
	}

	if (status === 500) {
		dispatch("setAlert", { type: "error", message: 'Whoops, something went wrong! 🙁' });
	}

	return response;
}

export default requestErrorHandling;
